import { useState, useEffect, FC } from 'react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import Hooks
import { useMenuItem } from 'hooks/UseMenuItem';
// Import UI Components
import { Tooltip, SkeletonLoader } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';

interface Props {
    menuItemId: number;
    value: number[];
}

const MenuItemInfoValue: FC<Props> = ({ value, menuItemId }) => {
    const { t } = useTranslation();
    const [menuItemLabels, setMenuItemLabels] = useState('');
    const { config, restore, isLoadingRestore, isLoadingConfig } = useMenuItem(menuItemId, false);

    useEffect(() => {
        if (!isNil(value) && !isNil(config)) {
            restore(value).then((data) =>
                setMenuItemLabels(
                    data
                        .filter(({ Id }) => value.includes(Id))
                        .map(({ Name }) => Name)
                        .join(', '),
                ),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, config]);

    return (
        <div>
            <SkeletonLoader isBusy={isLoadingConfig || isLoadingRestore}>
                {!isLoadingConfig &&
                    !isLoadingRestore &&
                    (isNil(value) ? (
                        <p className="key-value-items-subtitle"> {t(l.NA)} </p>
                    ) : (
                        <Tooltip text={menuItemLabels} position="right">
                            <div className="menu-item-info-value">{menuItemLabels}</div>
                        </Tooltip>
                    ))}
            </SkeletonLoader>
        </div>
    );
};

export default MenuItemInfoValue;
